export const API_PAGINATION_MAX_LIMIT = 20;
export const OCCURRENCES_TYPES_ALL_PROFILES_ID = '000000000000000000000000';
